export default class ClientCompanyTypeModel {
    ClientCompanyTypeId: number;
    ClientCompanyTypeName: string;
    Description: string; 
}
